export default __webpack_public_path__ + "static/media/bg2.0af73fcd.gif";